import React from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import { ServiceLocationProvider } from './utils/context/ServiceLocationContext'
import { GridDefaults } from '@moltech/molui/molgrid'


GridDefaults.set({
  grid: {
    scrollable: true,
    scrollHeight: "flex",
   

    sortMode: "single",
    showGridlines: true,
    resizableColumns: true,

    paginator: true,
    rowsPerPageOptions: [10, 25, 50, 100],
    rows: 25
  },
  column: {
    defaults: {
     
      sortable: true
    },
    datetime: {
      format: 'mm/dd/yyyy'
    },
    money: {
      body: (rowData, configs) => {
        const props = configs.column.props;
        const data = rowData[props.field];

        return data.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

      }
    }
  }
});

const App = () => {
  return (
    <div>
      <ServiceLocationProvider>
        <AppRoutes componentRoutes={ComponentNavigation} />
      </ServiceLocationProvider>
    </div>
  )
}

export default App